export default __webpack_public_path__ + "static/media/img-0078-japan-full-face.b4f59038.png";